import React from "react";
import CustomUserComponent from "components/CustomUserComponent/CustomUserComponent";
import Dropdown from "elements/dropdown";
import { IGroupSubscriptionMemberProps } from "./IGroupSubscriptionMemberProps";
import styles from './GroupSubscriptionMember.module.scss';

const GroupSubscriptionMember: React.FC<IGroupSubscriptionMemberProps> = (props) => {

  const generateActions = () => {
    const actions = [];

    if(!props.hideRemoveMemberOption) {
      actions.push(      {
        label: 'Remove Member',
        callback: () => props.removeMember(props.subscriptionMember),
      },);
    }

    return actions;
  }

  return (
    <div className={`${styles.table_row}${props.rowClassName ? ` ${props.rowClassName}` : ''}`}>
      <div className={styles.table_cell}>
        <CustomUserComponent
          user={props.subscriptionMember}
          group={props.group}
          disableMiniProfile
          badge={
            props.badge
          }
        />
      </div>

      {!props.hideRemoveMemberOption ? (
        <Dropdown
          useTippy
          showMenuDots
          tippyCompatibleActions
          actions={generateActions()}
        />
      ) : <></>}
    </div>
  );
};

export default GroupSubscriptionMember;
